import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { FormattedMessage, useIntl } from "react-intl";
import Card from "../components/main/components/why-chat-me-page/components/card";

const ContactPage = () => {
  const intl = useIntl();
  const cardsData = [
    {
      src: "/media/images/icon/mail.png",
      title: "Email",
      description: "Support@Cyberuni.vn",
      className: "w-12 h-12 md:w-10 md:h-8",
    },
    {
      src: "/media/images/icon/phone.png",
      title: intl.formatMessage({ id: "LANDINGPAGE.CONTACT.PHONE" }),
      description: "0865526282",
      className: "w-12 h-12 md:w-10 md:h-10",
    },
  ];
  return (
    <div className="min-h-screen bg-black flex flex-col w-full">
      <Header />
      <div className="mt-[90px] px-4 bg-[#071807]">
        <div className="max-w-[880px] mx-auto text-center px-[85px] py-20">
          <h1 className="pb-4 md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-[#FFFFFF] from-[15.54%] to-[#5AE65E] to-[67.98%] md:text-[80px] text-[40px]">
            <FormattedMessage id="LANDINGPAGE.CONTACT.TITLE" />
          </h1>
          <p className="text-[32px] text-white mb-2 px-[110px] leading-10">
            <FormattedMessage id="LANDINGPAGE.CONTACT.SUBTITLE" />
          </p>
          <p className="text-sm text-white mb-2">
            <FormattedMessage id="LANDINGPAGE.CONTACT.RESPONSE_TIME" />
          </p>
          <div className="flex gap-8 justify-center my-12">
            {cardsData.map((card, index) => (
              <div key={index} className="relative flex-1">
                <div className="relative z-10 pt-3 pb-5 h-full px-10 text-white bg-[#212121] rounded-2xl peer transition-colors">
                  <div className="flex items-center gap-4">
                    <img
                      src={card.src}
                      alt="contact-icon"
                      className={card.className}
                    />
                    <div className="py-4 pr-16 text-xl font-semibold">
                      {card.title}
                    </div>
                  </div>
                  <div className="text-base pr-2 text-gray-300 text-left">
                    {card.description}
                  </div>
                </div>
                <div className="absolute inset-0 rounded-2xl bg-green-500 transition-transform duration-1000 ease-in-out peer-hover:-rotate-2" />
              </div>
            ))}
          </div>

          <div className="bg-[#031602] rounded-3xl p-8 border border-[#0B4108EB]">
            <form className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white text-base text-left font-medium mb-2">
                    <FormattedMessage id="LANDINGPAGE.CONTACT.FORM.FULL_NAME" />
                  </label>
                  <input
                    type="text"
                    placeholder={intl.formatMessage({ id: "LANDINGPAGE.CONTACT.FORM.FULL_NAME_PLACEHOLDER" })}
                    className="w-full px-4 py-2 bg-[#060C05] text-white rounded-[11px] border border-gray-600 focus:border-green-500 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-white text-base text-left font-medium mb-2">
                    <FormattedMessage id="LANDINGPAGE.CONTACT.FORM.COMPANY_NAME" />
                  </label>
                  <input
                    type="text"
                    placeholder={intl.formatMessage({ id: "LANDINGPAGE.CONTACT.FORM.COMPANY_NAME_PLACEHOLDER" })}
                    className="w-full px-4 py-2 bg-[#060C05] text-white rounded-[11px] border border-gray-600 focus:border-green-500 focus:outline-none"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white text-base text-left font-medium mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    placeholder={intl.formatMessage({ id: "LANDINGPAGE.CONTACT.FORM.EMAIL_PLACEHOLDER" })}
                    className="w-full px-4 py-2 bg-[#060C05] text-white rounded-[11px] border border-gray-600 focus:border-green-500 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-white text-base text-left font-medium mb-2">
                    <FormattedMessage id="LANDINGPAGE.CONTACT.FORM.PHONE" />
                  </label>
                  <input
                    type="tel"
                    placeholder={intl.formatMessage({ id: "LANDINGPAGE.CONTACT.FORM.PHONE_PLACEHOLDER" })}
                    className="w-full px-4 py-2 bg-[#060C05] text-white rounded-[11px] border border-gray-600 focus:border-green-500 focus:outline-none"
                  />
                </div>
              </div>

              <div>
                <label className="block text-white text-base text-left font-medium mb-2">
                  <FormattedMessage id="LANDINGPAGE.CONTACT.FORM.MESSAGE" />
                </label>
                <textarea
                  placeholder={intl.formatMessage({ id: "LANDINGPAGE.CONTACT.FORM.MESSAGE_PLACEHOLDER" })}
                  rows="4"
                  className="w-full px-4 py-2 bg-[#060C05] text-white rounded-[11px] border border-gray-600 focus:border-green-500 focus:outline-none resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full cursor-pointer bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors"
              >
                <FormattedMessage id="LANDINGPAGE.CONTACT.FORM.SUBMIT" />
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
